import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-clinic-register-beta-user',
  templateUrl: './clinic-register-beta-user.component.html',
  styleUrls: ['./clinic-register-beta-user.component.scss']
})
export class ClinicRegisterBetaUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
